export const downloadFile = (blob: Blob, fileName: string, buttonRef?: React.RefObject<any>, callback?: () => void) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.setAttribute('download', fileName);
    link.setAttribute('style', 'display:none');
    if (buttonRef?.current) buttonRef.current.appendChild(link);
    link.click();
    link?.parentNode?.removeChild(link);
    if (callback) callback();
    URL.revokeObjectURL(url);
};

export const downloadFileUrl = (
    url: string,
    fileName: string,
    buttonRef?: React.RefObject<any>,
    callback?: () => void,
) => {
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.setAttribute('download', fileName);
    link.setAttribute('style', 'display:none');
    if (buttonRef?.current) buttonRef.current.appendChild(link);
    link.click();
    link?.parentNode?.removeChild(link);
    if (callback) callback();
    URL.revokeObjectURL(url);
};
